import { Able, MoveableManagerInterface } from "moveable";
import { html } from "tagged-jsx";
import Interactable from "../interactable";
import store from "../../store";
import * as actions from "../../actions";
import { JSXInternal } from "preact/src/jsx";
import CSSProperties = JSXInternal.CSSProperties;
import util from "../../util";
import OwnRenderer from "../renderer";
import { markAsModified } from "../mark-as-modified";
import MenuObject from "../menu-object";
import { ABLE_OFFSET } from "../interactable-constants";
import renderer from "../renderer";
import constants from "../../constants";

interface OptionsProps {
  interactable: Interactable;
}

const Options = {
  name: "options",
  props: {
    interactable: Interactable
  },
  render(moveable: MoveableManagerInterface<OptionsProps>, Renderer) {
    const isMobile = store.getState().isMobileVersion;
    const rect = moveable.getRect();
    const $contextBar = isMobile ? $('#app-header') : $('.context-bar');

    ABLE_OFFSET.reset();
    let top = ABLE_OFFSET.OPTIONS;
    if ($contextBar.length) {
      const contextBarRect = $contextBar[0].getBoundingClientRect();
      const elementRect = moveable.props.interactable.getElement()[0].getBoundingClientRect();
      const isBelowBar = elementRect.top + top - contextBarRect.bottom < 0;

      if (isBelowBar) {
        const newOffset = 20;
        ABLE_OFFSET.ANGLE += newOffset;
        ABLE_OFFSET.DIM += newOffset;
        top = rect.height + newOffset;
      }
    }

    const style = {
      position: "absolute",
      left: `${rect.width / 2}px`,
      top: `${top}px`,
      bottom: `20px`,
      color: "black",
      fontSize: "13px",
      whiteSpace: "nowrap",
      fontWeight: "bold",
      willChange: "transform",
      transform: "translate(-50%, 0px)",
    } as CSSProperties;

    const svgStyle = {
      margin: "0 5px"
    } as CSSProperties;

    util.nextTick(() => {
      const $delBtn = $('.mo-option.delete');
      const $copyBtn = $('.mo-option.copy');
      $delBtn.off('click');
      $copyBtn.off('click');

      $delBtn.on('click', function () {
        //@ts-ignore
        OwnRenderer.remove(moveable.props.interactable.$el, false);
        store.dispatch(actions.deselect());
      });

      $copyBtn.on('click', function () {
        //@ts-ignore
        const $copy = renderer.copy(moveable.props.interactable.$el);
        $copy.click();
      });
    });


    return html`<div class="mo-options" style=${style}>
      <div class="mo-option hint--bottom copy" data-hint="Copy">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="28" fill="#333" viewBox="0 0 20 20" style=${svgStyle}>
          <path d="M2,4H0V19a1,1,0,0,0,1,1H16V18H2Z"></path><path d="M19,0H5A1,1,0,0,0,4,1V15a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V1A1,1,0,0,0,19,0ZM18,14H6V2H18Z"></path><polygon points="11 12 13 12 13 9 16 9 16 7 13 7 13 4 11 4 11 7 8 7 8 9 11 9 11 12"></polygon>
        </svg>
      </div>
      <div class="mo-option hint--bottom delete" data-hint="Delete">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#333" viewBox="0 0 28 28">
          <path d="M10.438 6.688h-.188a.188.188 0 00.188-.188v.188h7.124V6.5a.19.19 0 00.188.188h-.188v1.687h1.688V6.5c0-.827-.673-1.5-1.5-1.5h-7.5c-.827 0-1.5.673-1.5 1.5v1.875h1.688V6.687zM22.25 8.374H5.75a.75.75 0 00-.75.75v.75c0 .103.084.188.188.188h1.415l.579 12.257c.038.8.698 1.43 1.498 1.43h10.64c.802 0 1.46-.628 1.498-1.43l.579-12.258h1.416A.188.188 0 0023 9.876v-.75a.75.75 0 00-.75-.75zm-3.11 13.688H8.86l-.567-12h11.414l-.567 12z"></path>
        </svg>
      </div>
    </div>`(Renderer.createElement);
  },
} as Able;

export default Options;
